import styled from "styled-components";

export const Text = styled.p`
  font-size: 24px;
  color: rgb(1, 34, 69);
  text-align: center;
  margin: 0;
  padding: 20px;
  border: 3px solid rgb(0, 170, 255);
  border-radius: 60px;
  width: 120px;
  margin: 40px auto;
`;
